export default __webpack_public_path__ + "static/media/README.64e6a4e8.md";